'use es6';

import { createSelector } from 'reselect';
const getProfilesState = state => state.storefront.profiles;
export const getStorefrontProfilesRequestState = createSelector([getProfilesState], state => state.requestState);
export const getStorefrontProfiles = createSelector([getProfilesState], state => state.results);
export const getStorefrontProfilesTotal = createSelector([getProfilesState], state => state.total);